import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@nx/angular';

import * as ProofOfDeliveryActions from './proof-of-delivery.actions';
import { ProofOfDeliveryService } from '../proof-of-delivery-service';
import { map } from 'rxjs/operators';

@Injectable()
export class ProofOfDeliveryEffects {
    init$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProofOfDeliveryActions.init),
            fetch({
                run: action => {
                    // Your custom service 'load' logic goes here. For now just return a success action...
                    return this.service
                        .getProofOfDelivery(action.parent)
                        .pipe(
                            map(proofOfDelivery =>
                                ProofOfDeliveryActions.loadProofOfDeliverySuccess(
                                    { proofOfDelivery }
                                )
                            )
                        );
                },
                onError: (action, error) => {
                    console.log('Error', error);
                    return ProofOfDeliveryActions.loadProofOfDeliveryFailure({
                        error,
                    });
                },
            })
        )
    );

    constructor(
        private readonly actions$: Actions,
        private service: ProofOfDeliveryService
    ) {}
}
